import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Unauthorized.module.scss';

const Unauthorized = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate('/dashboard'); 
  };

  return (
    <div className={styles.unauthorized}>
      <h1>Unauthorized Access</h1>
      <p>You do not have permission to view this page.</p>
      <button onClick={handleGoBack}>Go Back</button>
    </div>
  );
};

export default Unauthorized;
